import { ST } from '../lib/icons';
import { fmtDate } from '../lib/format';
import {
  allKeywordRows,
  keywordClicks,
  keywordSearches,
  positionStats,
  taskDailyClicks,
  type PfTask,
} from '../domain/positions';

export type CsvCell = string | number | null | undefined;

export function csvEscape(v: CsvCell): string {
  const s = v === null || v === undefined ? '' : String(v);
  return /[";\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
}

export function toCsv(head: string[], rows: CsvCell[][]): string {
  return [head, ...rows].map((r) => r.map(csvEscape).join(';')).join('\n');
}

export type CsvExport = { name: string; csv: string };

export function tasksCsv(tasks: PfTask[]): CsvExport {
  return {
    name: 'tasks.csv',
    csv: toCsv(
      ['Сайт', 'Сценарий', 'Пул прокси', 'Кликов в день', 'Ожидает', 'В работе', 'Успешно', 'Ошибка', 'Статус', 'Создана'],
      tasks.map((t) => [
        t.site,
        t.scenario,
        t.proxyTag,
        t.perDay || 0,
        t.clicksQueued,
        t.clicksRunning,
        t.clicksOk,
        t.clicksFailed,
        ST[t.status]?.[1] ?? t.status,
        fmtDate(t.createdAt),
      ]),
    ),
  };
}

export function positionsCsv(tasks: PfTask[]): CsvExport {
  return {
    name: 'positions.csv',
    csv: toCsv(
      ['Ключ', 'Сайт', 'Запросов', 'Кликов', 'Позиция', 'Запрос Bing', '7 дней назад', 'Кликов/день URL'],
      allKeywordRows(tasks).map(({ k, t }) => {
        const stats = positionStats(k);
        return [
          k.keyword,
          t.site,
          keywordSearches(k),
          keywordClicks(k),
          stats.current ?? '—',
          k.lastQuery || '',
          stats.previous ?? '—',
          taskDailyClicks(t),
        ];
      }),
    ),
  };
}
